import { useSelector } from 'react-redux'

import { selectUserAccountPreferences } from '@/features/domain/user'
import { timeUtils } from '@/server-data'

import { useTexts } from './useTexts'

interface Props {
  tw: uui.domain.rm.TimeWindow
}

export function TimeWindow(props: Props) {
  const { tw } = props

  const accountPreferences = useSelector(selectUserAccountPreferences)
  const texts = useTexts()

  const start = timeUtils.formatSecondsFromMidnight(tw.startSec, accountPreferences.timeFormat)
  const end = timeUtils.formatSecondsFromMidnight(tw.endSec, accountPreferences.timeFormat)

  return texts.timeWindow(start, end)
}
